export default {
      id: "email-usage",
      viewBox: "0 0 48 48",
      url: "/assets/" + "icons.svg#email",
      toString: function () {
        return this.url;
      }
    }